import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { server } from './global.service';
import { server_ip } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { EncryptionDecryptionService } from './encryption-decryption.service';

var header = {
  Accept: "application/json",
  "Content-Type": "application/json",
}


@Injectable({
  providedIn: 'root'
})


export class admin_service {
  constructor(private backend: server,public http:HttpClient, private encryptionDecryptionService: EncryptionDecryptionService) { }

  
  // sendOTP(a):Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers = headers.append('Content-Type', 'text/xml');
  //   headers = headers.append('Accept', 'text/xml');
  //   headers = headers.append('X-IBM-Client-Id', '4bbbdcad-a1da-435e-b283-910249cb59bf');
  //   headers = headers.append('X-IBM-Client Secret', 'cG3dK1sQ1rU0oY7vO7oR4kB2gK6vD5sY4iX0xE2fT0iD6hC7jN');
  //   let body =  a
  //   return this.http.post('http://www.yesbank.in/OTPService', body , { headers: headers, responseType: 'text' });
  // }
  sendOTP(data):Observable<any>{
    return this.backend.post(server_ip + "/request_otp",data, header)
  }

  checkOTP(data):Observable<any>{

    return this.backend.post(server_ip + "/validate_otp", data, header)

  }

  checkOTPForUserUnlock(data):Observable<any>{

    return this.backend.post(server_ip + "/unlock_validate_otp", data, header)

  }

  login(data):Observable<any> {
    return this.backend.post(server_ip + "/login", data, header)
  }
  forgotpassword(data):Observable<any>{
    let encryptedData = this.encryptionDecryptionService.encryptedPassword(JSON.stringify(data));
    encryptedData = encodeURIComponent(encryptedData);

    return this.backend.get(server_ip + "/forgotPassword?username="+encryptedData);
  }
  validateResetToken(data):Observable<any>{
    return this.backend.get(server_ip + "/validateResetToken?token="+data);
  }
  resetNewPassword(data):Observable<any>{
    return this.backend.post(server_ip + "/resetNewPassword",data,header);
  }
  login_out(data):Observable<any> {
    return this.backend.post(server_ip + "/log_out", data, header)
  }

  get_admin_list(page,size,filter):Observable<any> {
    return this.backend.get(server_ip + "/list_of_admin?page="+page+"&size="+size+"&filter="+filter);
  }

  get_admin_by_id(data):Observable<any>{
    return this.backend.post(server_ip+"/view_admin_by_id",data,header)
  }

  getServicesForAdmin():Observable<any>{
    return this.backend.get(server_ip+"/getServicesForAdmin")
  }

  userUnblock(data):Observable<any>{
    return this.backend.get(server_ip + "/user-unlock?username="+data);
  }

  resetNewPasswordAndUserUnlock(data):Observable<any>{
    return this.backend.post(server_ip + "/resetPassword_UnlockUser",data,header);
  }
  
  resetApiBankingNewPassword(data):Observable<any>{
    return this.backend.post(server_ip + "/resetNewPasswordForApiBanking",data,header);
  }

  resetNewPasswordForDormantUser(data):Observable<any>{
    return this.backend.post(server_ip + "/resetPassword_DormantUser",data,header);
  }

  checkOTPForDormantUser(data):Observable<any>{
    return this.backend.post(server_ip + "/dormant_validate_otp", data, header);
  }

  VKYCSendOTP(data):Observable<any>{
    return this.backend.post(server_ip + "/kyc_request_otp", data, header);
  }

  VKYCVerifyOTP(data):Observable<any>{
    return this.backend.post(server_ip + "/kyc_verify_otp", data, header);
  }

  refreshToken(data):Observable<any>{
    return this.backend.post(server_ip + "/refresh_token", data, header);
  }

  checkIfMobileDuplicate(data):Observable<any>{
    return this.backend.get(server_ip + "/isValidMobile"+data);
  }

  checkIfEmailDuplicate(data):Observable<any>{
    return this.backend.get(server_ip + "/isValidEmail?email="+data);
  }

  getCountrylist():Observable<any> {
    return this.backend.post(server_ip+"/getCountries",null,header);
  }

  updateMobileNumber(data):Observable<any> {
    return this.backend.post(server_ip+"/updateMobileNo",data,header);
  }

}
